import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../../config";
import successToast from "../../toast/successToast";
import errorToast from "../../toast/errorToast";
import FormTextField from "../../form/text";
import { FormDropDown } from "../../form/dropdown";
import { FormTextAreaField } from "../../form/text-area";
import { useEffect, useState } from "react";
import { FormLocationPickerField } from "../../map/map-selector";
import { api } from "../../../redux/apis/api";

const CustomerDeliveryAddressCreateModal = ({
  isOpen = false,
  onClose = () => {},
  listFnc = () => {},
  customer_id,
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const naviagte = useNavigate();
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  const initialValues = {
    customer_id: customer_id ?? "",
    name: "",
    location: {
      lat: "",
      lng: "",
    },
    address: "",
    state_id: "",
    city_id: "",
    pincode: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/customer/delivery-address/create`, values)
      .then((response) => {
        successToast(response.message);
        onClose();
        console.log(response, "response");
        listFnc();
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
    fetchCityDropDownData();
  }, []);

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[50rem] w-full md:p-8 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              <Form>
                <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                  <h2 className="text-xl font-semibold capitalize">
                    customer delivery address - Create
                  </h2>
                  <div className="flex gap-3 items-center">
                    <button
                      onClick={() => onClose()}
                      type="button"
                      className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                    >
                      Create
                    </button>
                  </div>
                </div>
                <section className="overflow-auto w-full h-[60vh]">
                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <FormTextField
                        name={"name"}
                        label={"name"}
                        placeholder={`Enter name`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextAreaField
                        name={"address"}
                        label={"address"}
                        placeholder={`Enter address`}
                        rows={3}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="state_id"
                        label="state"
                        options={stateList}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="city_id"
                        label="city"
                        options={citiesList}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"pincode"}
                        label={"pincode"}
                        placeholder={`Enter pincode`}
                      />
                    </div>
                    <div>
                      <FormLocationPickerField
                        name={"location"}
                        label={"location"}
                      />
                    </div>
                  </section>
                </section>
              </Form>
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerDeliveryAddressCreateModal;
